import React, { FC } from 'react'
import { useRouteMatch } from 'react-router-dom'
import isAuthenticated from '../../routes/isAuthenticated'
import { Container } from 'react-bootstrap'

interface Props {
  height: number;
  width:  number;
}

const NoMatch: FC<Props> = ({ width, height }: Props) => {
  const match = useRouteMatch()

  return (
    <Container 
      style={{
        paddingTop:20, 
        backgroundColor: '#f5f5f5', 
        width:width, 
        height:height-20, 
        maxWidth:width, 
        overflow:'auto'
      }}>
      {match.path && match.path !== '/' ? 'Page not found' : ''}
    </Container>
  )
}

export default isAuthenticated(NoMatch)
